<template>
  <div>
    <h2>
      <span class="text-success">{{response_msg}}</span>
    </h2>
    <h2>
      <span class="text-danger">{{response_error}}</span>
    </h2>  
 <form class="col s12" action="#" method="post">
                        <div class="row">
                            <div class="input-field col s6">
                                <i class="mdi-action-account-circle prefix white-text"></i>
                                <input id="icon_prefix" v-model="name" name="name" type="text" class="validate white-text">
                                <label for="icon_prefix" class="white-text">First Name</label>
                            </div>
                            <div class="input-field col s6">
                                <i class="mdi-communication-email prefix white-text"></i>
                                <input id="icon_email"  v-model="emailadress" name="email" type="email" class="validate white-text">
                                <label for="icon_email" class="white-text">Email</label>
                            </div>
                            <div class="input-field col s12">
                                <i class="mdi-editor-mode-edit prefix white-text"></i>                                
                                <textarea  name="message" v-model="message" class="materialize-textarea white-text"></textarea>
                                <label for="icon_prefix2" class="white-text">Message</label>
                            </div>
                            <div class="col offset-s7 s5">                                
                                <button  :disabled="contact_me_availeable" type="button" v-on:click="Submit()" class="btn waves-effect waves-light red darken-1">{{SubmitBtn}}<i class="mdi-content-send right white-text"></i></button>                              
                            </div>
                        </div>
                    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { API } from "../../services/";

export default {
  name: "ContactForm",  
  data() {
    return {
      SubmitBtn: 'Submit',
      contact_me_availeable: false,
      disabled: null,
      emailadress: null,
      message: null,
      name: null,
      response_msg: "",
      response_error: ""
    };
  },
  methods: {        
    Submit() {
      console.log(this.emailadress, this.message, this.name)
      API.doSubmitContact(this.emailadress, this.message, this.name)
      .then(response => {
        this.contact_me_availeable = true
        console.log(response.data[0])
        if (response.data[0]) {
          this.response_error = "";

          this.SubmitBtn = 'Thanks'
          this.response_msg = 'Thanks for submit your message';                
        } else {
          this.response_error = 'Ups something was wrong here';
        }
      });
    }
  }
};
</script>
